import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-289cf095"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Авторы", -1));

const _hoisted_4 = {
  class: "sorting-line"
};
const _hoisted_5 = {
  class: "sorting-tabs"
};
const _hoisted_6 = {
  class: "search"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "search-button"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AuthorsByAlpComponent = _resolveComponent("AuthorsByAlpComponent");

  const _component_AuthorsByPeriodComponent = _resolveComponent("AuthorsByPeriodComponent");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: _normalizeClass({
      active: $data.tabActive === 0
    }),
    onClick: _cache[0] || (_cache[0] = $event => $data.tabActive = 0)
  }, "По алфавиту", 2), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: _normalizeClass({
      active: $data.tabActive === 1
    }),
    onClick: _cache[1] || (_cache[1] = $event => $data.tabActive = 1)
  }, "По периоду", 2)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("input", {
    type: "text",
    class: "search-input",
    placeholder: "Поиск",
    onChange: _cache[2] || (_cache[2] = $event => $data.search = $event.target.value)
  }, null, 32), _hoisted_7])]), $data.tabActive === 0 ? (_openBlock(), _createBlock(_component_AuthorsByAlpComponent, {
    key: 0,
    search: $data.search
  }, null, 8, ["search"])) : _createCommentVNode("", true), $data.tabActive === 1 ? (_openBlock(), _createBlock(_component_AuthorsByPeriodComponent, {
    key: 1,
    search: $data.search
  }, null, 8, ["search"])) : _createCommentVNode("", true)])]);
}